import { toast } from "react-toastify";
import { observable } from "mobx";
import { api } from "../../api";

export class _ParauapebasStore {
  obs = observable({
    tasks_parauapebas: [] as any[],
    tasks_length: 0 as number,
    loading_solicitacao: false as boolean,
    loading_arquivos: false as boolean,
    loading_tasks: false as boolean,
    open_solicitar: false as boolean,
    page_agendamentos: 1 as number,
    index_agendamentos: [] as any,
    length_agendamentos: 0 as number,
    open_iframe: false as boolean,
    base64: "" as string,
    agendamentos_filter: false as boolean,
    detalhes_length: 0 as number,
    detalhes_itens: []
  })

  async handleTasksPaged(paged: number, cnpj: string, date1: string, date2: string) {

    try {

      let data = {
        page: paged,
        limit: 15,
        cnpj: cnpj,
        date1: date1,
        date2: date2
      }

      let resp = await api.post("/api/parauapebas/index", data);

      this.obs.tasks_parauapebas = [];
      this.obs.tasks_length = 0

      if (resp.data.itens.length == 0) {

        toast.warning('Nenhuma solicitação foi encontrada.', {});

      } else {

        this.obs.tasks_parauapebas = resp.data.itens;

        this.obs.tasks_length = resp.data.count;

      }

    } catch (ex) { }

    this.obs.loading_tasks = false
  }

  async handleSolicitaParauapebas(params: any) {

    this.obs.loading_solicitacao = true

    try {

      let resp = await api.post("/api/parauapebas/create", params);

      if (resp.data) {

        toast.success('Solicitação realizada com sucesso!', {});

      } else {

        toast.error("Infelizmente, não foi possível realizar a solicitação para algumas empresas.", {});

      }

    } catch (ex) {

      toast.error("Erro ao realizar Solicitação, tente novamente mais tarde.", {});

    }

    ParauapebasStore.obs.loading_solicitacao = false

  }

  async consultaArquivos(id: string) {

    try {

      let resp = await api.get(`/api/parauapebas/arquivos/${id}`);

      return resp.data;

    } catch (ex) {

      toast.error('Erro ao consultar arquivos Parauapebas, tente novamente mais tarde.', {});
    }

  }

  async downloadArquivos(fileName: string) {

    this.obs.loading_arquivos = true

    try {

      let resp = await api.get(`/api/parauapebas/download/${fileName}`);

      if (resp.data.file) {

        const linkSource = `data:application/zip;base64,${resp.data.file}`;
        const downloadLink = document.createElement("a");

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

      } else {

        toast.error('Não foi encontrado um arquivo para download.', {});

      }

    } catch (ex) {

      toast.error('Erro Download Arquivo, tente novamente mais tarde.', {});

    }

    this.obs.loading_arquivos = false

  }

  async handleIndexAgendamentos(page: number) {

    let params = {
      page: page,
      limit: 5,
      recorrente: this.obs.agendamentos_filter
    }

    let resp = await api.post(`/api/parauapebas/agendamento/index`, params);

    this.obs.index_agendamentos = []
    this.obs.length_agendamentos = 0

    if (resp.data.itens.length > 0) {

      this.obs.index_agendamentos = resp.data.itens

      this.obs.length_agendamentos = resp.data.count

    }
  }

  async handleDeleteAgendamento(id: string) {
    try {

      let resp = await api.delete(`/api/parauapebas/agendamento/${id}`);

      if (resp.data.ok) {

        toast.success('Agendamento deletado com sucesso.', {});
        this.handleIndexAgendamentos(1)

      } else {

        toast.error('Erro ao deletar agendamento, tente novamente mais tarde.', {});

      }

    } catch (ex) {

      toast.error('Erro ao deletar agendamento, tente novamente mais tarde.', {});

    }

  }

  async buscaDetalheSolicitacao(id: string, page: number, cnpj: string) {

    try {

      let data = { agendamento_id: id, page: page, limit: 5, cnpj: cnpj };

      let resp = await api.post(`/api/parauapebas/solicitacao`, data);

      this.obs.detalhes_length = 0
      this.obs.detalhes_itens = []

      if (resp.data.itens.length > 0) {

        this.obs.detalhes_length = resp.data.count
        this.obs.detalhes_itens = resp.data.itens

      }

    } catch (ex) { }

  }

  async buscaSolicitacao(id: string, page: number, cnpj: string) {

    try {

      let data = { agendamento_id: id, page: page, limit: 15, cnpj: cnpj };

      let resp = await api.post(`/api/parauapebas/solicitacao`, data);

      this.obs.tasks_parauapebas = [];
      this.obs.tasks_length = 0

      if (resp.data.itens.length > 0) {

        this.obs.tasks_length = resp.data.count
        this.obs.tasks_parauapebas = resp.data.itens

      }

    } catch (ex) { }

  }


}

export const ParauapebasStore = new _ParauapebasStore();
